export var CART_ID_COOKIE_NAME = 'basket_id';
export var CART_API_URL = '/basketapi/api/v1';
export var CART_QUANTITY_URL = 'basket';
export var CART_REGION_URL = 'region/list';